import { Controller } from '@hotwired/stimulus'
import Cookies from 'js-cookie'

const VISIBLE_POSITION = 91 // ヘッダーの高さ

export default class extends Controller {
  static targets = ['container', 'facility']

  initialize () {
    this._lastScrollPosition = 0
    this._ticking = false
    this._onScroll = () => {
      this._lastScrollPosition = window.scrollY
      const isEnabled = this.element.classList.contains('js-enable')
      if (!this._ticking && isEnabled) {
        window.requestAnimationFrame(() => {
          this.toggleVisibility(this._lastScrollPosition)
          this._ticking = false
        })
        this._ticking = true
      }
    }
    window.addEventListener('scroll', this._onScroll)
  }

  disconnect () {
    if (this._onScroll) {
      window.removeEventListener('scroll', this._onScroll)
    }
  }

  connect () {
    const ids = JSON.parse(Cookies.get('check_nursing_facility_ids') || '[]')
    if (Array.isArray(ids) && ids.includes(this.facilityId())) {
      this.element.classList.add(`${this.className()}::bookmarked`)
    }
  }

  facilityId () {
    return parseInt(this.element.dataset.facilityid)
  }

  className () {
    return this.element.dataset.classname
  }

  toggleVisibility (scrollPosition) {
    const visibleClass = `${this.className()}::visible`
    this.containerTarget.classList.toggle(visibleClass, scrollPosition > VISIBLE_POSITION)
  }

  openModal (e) {
    const modalIndex = e.target.dataset.modalIndex
    window.dispatchEvent(new CustomEvent('open-condition-search-modal', { detail: { modalIndex } }))
  }
}
